import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import { SubscriptionsResponse } from './types';

const client = createApiClient(`${Config.billing_api_url}/v3/subscriptions`);

/**
 * Billing API client.
 */
export const subscriptionClient = {
  /**
   * Get subscription.
   */
  get: async (token: string) => client.get<SubscriptionsResponse>('', token),
};
